(ns manage.adset-preview-panel.db.content-function-version
  (:require [common.db.interceptors :as interceptors]
            [goog.string :as gstring]
            [manage.resource.content-function-version :as resource.content-function-version]
            [re-frame.core :as rf]))

;; Initialize state for content function versioning of preview
(rf/reg-event-fx :adset-preview.content-function-version/init
  (fn [_ _]
    {:forward-events [{:register :adset-preview.content-function-version/get-overview-success
                       :events #{:resource.adset-preview/get-content-function-overview-success}
                       :dispatch-to [:adset-preview.content-function-version/get-overview-success]}]
     :dispatch-interval {:register :adset-preview.content-function-version/polling
                         :event [:resource.adset-preview/get-content-function-overview]
                         :ms 5e3}}))

;; Cleanup state for content function versioning of preview
(rf/reg-event-fx :adset-preview.content-function-version/destroy
  (fn [_ _]
    {:forward-events [{:unregister :adset-preview.content-function-version/get-overview-success}]
     :dispatch-interval {:unregister :adset-preview.content-function-version/polling}}))

;; Triggered on each `get-content-function-overview-success`
(rf/reg-event-fx :adset-preview.content-function-version/get-overview-success
  [interceptors/forwarded-event
   resource.content-function-version/overview-success-response->versions
   (rf/inject-cofx :query-params)
   (rf/inject-cofx :sub :resource.content-function-version/active-version)
   (rf/inject-cofx :sub :adset-preview.core/content-function)]
  (fn [{:keys [db]
        :resource.content-function-version/keys [active-version]
        :adset-preview.core/keys [content-function]
        :as cofx} [_ versions]]
    (cond
      (not active-version) ; set versions and version
      (let [query-param-stage (get-in cofx [:query-params :stage])
            version (resource.content-function-version/versions->available-version
                     versions [query-param-stage "published"])]
        {:db (assoc db :adset-preview.content-function-version/content-function-versions versions)
         :dispatch [:adset-preview.content-function-version/set-versions-and-version versions version]})

      (nil? content-function) ; there is an active content function but its data has not been fetched
      {:fx [[:dispatch [:resource.adset-preview/get-data (:name active-version)]]]}

      ;; check for changes/removals active content-function
      :else {:dispatch [:adset-preview.content-function-version/checksum-active-content-function versions]})))

;; Set/store versions and version and refresh data
(rf/reg-event-fx :adset-preview.content-function-version/set-versions-and-version
  (fn [_ [_ versions version]]
    {:dispatch-n [[:resource.content-function-version/set-versions versions]
                  [:adset-preview.content-function-version/activate-version version]]}))

;; Update versions and refresh data
(rf/reg-event-fx :adset-preview.content-function-version/update-versions
  (fn [_ [_ versions]]
    {:dispatch-n [[:resource.content-function-version/set-versions versions]
                  [:adset-preview.content-function-version/refresh-version]]}))

;; Activate version by store version in db and request data
(rf/reg-event-fx :adset-preview.content-function-version/activate-version
  (fn [_ [_ version]]
    {:dispatch-n [[:resource.content-function-version/activate-version version]
                  [:resource.adset-preview/get-data
                   (when (not= "published" version) version)]]}))

;; refresh current active version
(rf/reg-event-fx :adset-preview.content-function-version/refresh-version
  [(rf/inject-cofx :sub [:resource.content-function-version/active-version {:only-staged true}])]
  (fn [{:resource.content-function-version/keys [active-version]} _]
    {:dispatch [:resource.adset-preview/get-data (:name active-version)]}))

;; Check if content-function has changed/removed over time
(rf/reg-event-fx :adset-preview.content-function-version/checksum-active-content-function
  [(rf/inject-cofx :sub :resource.content-function-version/active-version)]
  (fn [{:keys [db]
        :resource.content-function-version/keys [active-version]}
       [_ versions]]
    (let [content-function-versions (get db :adset-preview.content-function-version/content-function-versions {})
          stored-active-version-id (when content-function-versions
                                     (get content-function-versions (:name active-version)))
          missing-active-version? (not (get versions (:name active-version)))
          changed-active-version? (and (nat-int? stored-active-version-id)
                                       (not= stored-active-version-id (:id active-version)))
          ->events (comp (partial into []) concat)]
      {:db (assoc db :adset-preview.content-function-version/content-function-versions versions)
       :dispatch-n
       (->events
        ;; show missing active version notification
        (when missing-active-version?
          (let [version (resource.content-function-version/versions->available-version
                         versions ["published"])]
            [[:adset-preview.notifications/show
              :missing-active-version
              {:action {:label (gstring/format "Switch to %s content version" version)
                        :on-click #(do (rf/dispatch [:adset-preview.content-function-version/set-versions-and-version versions version])
                                       (rf/dispatch [:adset-preview.notifications/hide :changed-active-version])
                                       (rf/dispatch [:adset-preview.notifications/hide :missing-active-version]))}
               :message "Current version of the adset content can not be found."}]]))

        ;; show changed active version notification
        (when changed-active-version?
          [[:adset-preview.notifications/show
            :changed-active-version
            {:action {:label "Refresh content"
                      :on-click #(do (rf/dispatch [:adset-preview.content-function-version/update-versions versions])
                                     (rf/dispatch [:adset-preview.notifications/hide :changed-active-version]))}
             :message "Changes have been made to the adset content."}]])

        ;; hide all notifications
        (when (every? not [missing-active-version? changed-active-version?])
          [[:adset-preview.notifications/hide :missing-active-version]
           [:adset-preview.notifications/hide :changed-active-version]]))})))
